<template>
    <div id="aqt_content">
      <div class="content_items">
        <div class="line line1"></div>
        <p class="title title_size1">阿启泰的服务</p>
        <p class="title title_size2">服务形式多样建立互联网全产品体系，一站式服务，提供整体产品解决方案。坚持以客户服务为中心，以奋斗者为本，长期艰苦奋斗，不断探索新技术。</p>
        <img src="../../assets/img/serve1.png" class="serve1"/>
        <div class="own">
          <img src="../../assets/img/serve2.png" class="serve2"/>
          <p class="title title_size1">阿启泰特有的服务</p>
          <img src="../../assets/img/serve3.png" class="serve2"/>
        </div>

            <div class="content_item" v-for="(serve,index) in serveArr" :key="index">
              <div class="line line4"></div>
              <p class="title title_size1">{{serve.title}}</p>
              <p class="title title_size2">{{serve.describe}}</p>
              <img :src="serve.img" class="serve1"/>
            </div>
            <ul class="serve_more">

              <li class="serve_more_item" v-for="(industry,index) in industrys" :key="index">
                <img :src="industry.img"/>
                <p class="territory">{{industry.name}}</p>
              </li>
        </ul>
      </div>

    </div>
</template>

<script>
    export default {
      data(){
        return {
          serveArr:[

            {
              title:'市场定位',
              describe:'通过专业的调研和分析做出准确的定位，树立产品独特的形象。\n',
              img:require('../../assets/img/serve4.png')
            },
            {
              title:'需求分析',
              describe:'通过与需求方沟通，了解所需服务，制定相关定制化服务。',
              img:require('../../assets/img/index9.png')
            },
            {
              title:'UI设计',
              describe:'专业的设计团队根据客户需求个性化定制产品效果和交互设计。',
              img:require('../../assets/img/serve6.png')
            },
            {
              title:'产品研发',
              describe:'有专业的前后台人员根据客户需求定制开发产品。',
              img:require('../../assets/img/serve7.png')
            },
            {
              title:'功能测试',
              describe:'专业人员核对客户产品需求，功能并测试产品bug和交互性。',
              img:require('../../assets/img/serve8.png')
            },
            {
              title:'项目交付',
              describe:'相关人员对接客户，进行项目内容的确认交付工作。',
              img:require('../../assets/img/serve9.png')
            },
            {
              title:'阿启泰的服务行业',
              describe:'',
              img:require('../../assets/img/index10.png')
            }
          ],
          industrys:[
            {
              img:require('../../assets/img/serve11.png'),
              name:'金融行业'
            },
            {
              img:require('../../assets/img/serve12.png'),
              name:'教育行业'
            },
            {
              img:require('../../assets/img/serve13.png'),
              name:'游戏行业'
            },
            {
              img:require('../../assets/img/serve14.png'),
              name:'政府部门'
            },{
              img:require('../../assets/img/serve15.png'),
              name:'医疗行业'
            },
            {
              img:require('../../assets/img/serve16.png'),
              name:'各类行业'
            }
          ]
        }
      }
    }
</script>

<style scoped lang="less">
  #aqt_content{
      padding-top:4rem;
    .line{
      margin: 0 auto;
      width: 10%;
      height: 0.1rem;
      text-align: center;
      margin-top: 3rem;
      margin-bottom: 2rem;
    }
    .line1{
      background-color:#F5A623;
    }
    .title{
      margin-left: 0.5rem;
      margin-right: 0.5rem;
      text-align: center;
      letter-spacing: 0.1rem;
    }

    .title_size1{
      font-size: 1.1rem;
      color: #F4FAFF;
    }
    .title_size2{
      font-size: 0.8rem;
      color: #D3DFFF;
      line-height: 1.2rem;
      marign-top: 1rem;
      margin-top: 1rem;
      text-align:center;
    }
    .serve1{
      width: 60%;
      margin-left: 20%;
      margin-top: 2rem;
    }
    .own{
      width:100%;
      height:100%;
      margin-top:2rem;
      display:flex;
      flex-direction:row;
      justify-content: space-around;
      .serve2{
        width:2rem;
        height:2rem;
      }

    }

    .content_item{
      .line4{
        background-color:#3399ED;
      }

    }
    .serve_more{
      width:100%;
      height:auto;
      display:flex;
      flex-direction:row;
      flex-wrap:wrap;
      margin-top:2rem;
      .serve_more_item{
        width:50%;
        height:3rem;
        display:flex;
        flex-direction:row;
        margin-bottom:1rem;
        img{
          width:2rem;
          height:2rem;
          margin-left:1rem;
          margin-right:1rem;
        }
        .territory{
          font-size:0.8rem;
          color:#D3DFFF;
          margin-top:0.3rem;
        }
      }

    }
    .aqt_bottom{
      width: 100%;
      height: 15rem;
      background-color: #272D74;
      margin-bottom: 0rem;

    }
    .aqt_bottom_items{
      width: 60%;
      height: 4rem;
      margin-left: 22%;
      display:flex;
      flex-direction:row;
      justify-content: space-between;
    }
    .aqt_bottom_items img {
      width: 2rem;
      height: 2rem;
      margin-top: 0.2rem;
      margin-left: 15%;
    }
    .aqt_bottom_item{
      text-align:center;
      font-size:0.7rem;
      color:#D3DFFF;
    }
    .dress, .telephone{
      color:#D3DFFF;
      font-size:0.8rem;
      margin-bottom:0.5rem;
      text-align: center;
    }

  }


</style>
